import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingPlaceholder from './LoadingPlaceholder';
import OfferModal from './OfferModal';

const Offerwalls = () => {
    const [offerwall, setOfferwall] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedOffer, setSelectedOffer] = useState(null);

    var adslotId = 17787;
	var external_identifier = (data['id'] ? data['id'] : 1);
    var num_offers = 1000;
    var include_cpe = 1;
    var include_mobile_offers = 1
    var api_url = `https://www.ayetstudios.com/offers/offerwall_api/${adslotId}?external_identifier=${external_identifier}&num_offers=${num_offers}&include_cpe=${include_cpe}&include_mobile_offers=${include_mobile_offers}`;

	useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(api_url);
                setOfferwall(response.data['offers']);
            } catch (error) {
                console.error('Error fetching data:', error);
                setError('Failed to load data. Please try again later.');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    const handleItemClick = (offer) => {
        if(data['id']){
            setSelectedOffer(offer);
            const offerModal = new bootstrap.Modal(document.getElementById("offerModal"));  
            offerModal.show();
        }else{
            const signInModal = new bootstrap.Modal(document.getElementById("SigninForm"));
            signInModal.show();
        }
    }
    
    const generateOfferwallItem = (val) => {
        const click_url = val.tracking_link;
        const payout_vc = val.payout;
        const app_icon = val.icon;
        const app_name = val.name;

        return (
            <li key={val.id} onClick={() => handleItemClick(val)}>
                <div className="item">
                    <div className="imageWrapper" /* dangerouslySetInnerHTML={{ __html: coreTSW.generateImage(val.icon, val.name, undefined, undefined, { class: 'imaged w64 img-fluid border rounded-md shadow' }) }} */ >
                        <img src={app_icon} alt={app_name} className="imaged w64 img-fluid border rounded-md shadow"/>
                    </div>
                    <div className='in'>
                        <div>
                            <span className="Xtext-truncateX">
                                {app_name}
                            </span>
                            <div className='text-muted'>{val.conversion_instructions_short}</div>
                            <small className="text-muted" dangerouslySetInnerHTML={{ __html: coreTSW.convertToBadge('platformToLabel', val.platform, val) }}></small>
                        </div>
                        <div className="btn-group" role="group" /* dangerouslySetInnerHTML={{ __html: coreTSW.generateLink(val.tracking_link, '', '_blank', { buttonClassName: 'btn-warning btn-sm btn-block', iconName: 'fa-coins fa-fw', spanClass: 'd-none d-sm-block', text: `+${val.payout} &nbsp;COIN(s)`, clickEvent: 'style="width: 100%;"' }) }} */ >
							<a className="btn btn-warning btn-sm btn-block" href={click_url} target="_blank" style={{width: "100%"}}>
								<i className="bi bi-plus m-0"></i> {payout_vc} 
								<span className="d-none d-sm-block">&nbsp;$COIN</span>
							</a>
                        </div>
                    </div>
                </div>
            </li>
        );
    };

    if (loading) {
        return <LoadingPlaceholder />;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <>
            <ul className="listview image-listview media placeholder-glow mb-2">
                {offerwall.length > 0 ? offerwall.map(generateOfferwallItem) : ''}
            </ul>
            <OfferModal selectedOffer={selectedOffer}/>
        </>
    );
}

export default Offerwalls;
